const variables = {
  /* colors */

  // base
  baseWhite: '#fff',
  baseBlack: '#2d2f34',

  // grey
  gray10: '#f8f9fc',
  gray20: '#e6eaf1',
  gray30: '#dbdee6',
  gray40: '#c0c6d1',
  gray60: '#a2a9b8',
  gray: '#8a90a4',
  gray80: '#697087',
  gray90: '#697087',

  // brand
  brandBlue10: '#f0f5ff',
  brandBlue20: '#e0ebff',
  brandBlue40: '#99beff',
  brandBlue60: '#3271e2',
  brandBlue: '#0050cf',
  brandBlue80: '#003594',
  brandBlue90: '#001e64',

  // success
  successGreen10: '#f0fdf8',
  successGreen20: '#d8f7e3',
  successGreen40: '#94f1b5',
  successGreen60: '#0be187',
  successGreen: '#00bf6f',
  successGreen80: '#008a50',

  // danger
  dangerRed10: '#fef5f7',
  dangerRed20: '#fde2e8',
  dangerRed40: '#fec0cb',
  dangerRed60: '#fe6984',
  dangerRed: '#f31b4f',
  dangerRed80: '#c20a36',

  // warning
  warningYellow10: '#fff6e0',
  warningYellow20: '#ffecbd',
  warningYellow40: '#ffd670',
  warningYellow60: '#ffc32e',
  warningYellow: '#ffb600',
  warningYellow80: '#d79b06',

  /* typography */

  fontFamily: "'Inter', sans-serif",

  // weight
  fontWeightSemiBold: 600,
  fontWeightBold: 700,

  // size
  fontSizeXl: 18,
  fontSizeL: 16,
  fontSize: 14,
  fontSizeS: 12,

  /* radius */

  borderRadiusS: 4,
  borderRadius: 8,
  borderRadiusL: 12,

  /* shadows */

  boxShadow: '0 1px 2px rgb(43 79 163 / 4%), 0 4px 16px rgb(43 79 163 / 10%)',
  boxShadowHover: '0 2px 2px rgb(43 79 163 / 4%), 0 4px 16px rgb(43 79 163 / 15%)',
  boxShadowDropdown: '0 0 0 1px #e6eaf1 0 4px 12px rgb(43 79 163 / 6%)',

  space: 8,

  /* Control size */

  controlSmallSize: 32,
  controlMiddleSize: 40,
  controlLargeSize: 48
} as const

export default variables
